export * from './broadcastMessage.service';
import { BroadcastMessageService } from './broadcastMessage.service';
export const APIS = [BroadcastMessageService];
